var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevronRightPrimary = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m5.83 10.726 2.82-2.55a.268.268 0 0 0 0-.397L5.863 5.277a.603.603 0 0 1-.046-.85.599.599 0 0 1 .847-.046l3.504 3.146a.603.603 0 0 1 .001.895L6.635 11.62a.599.599 0 0 1-.848-.044.603.603 0 0 1 .044-.85Z",
  fill: "#EA5800"
})));
export default SvgChevronRightPrimary;